module.exports = __webpack_public_path__ + "static/turquia-020-d4d7e429270b13f32d2ac6c87ce4b568.jpg";